import React from 'react'
import { SVGIconProps } from '../types'
const SvgMnone = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 9.333a1.99 1.99 0 0 0 1.993-2l.007-4c0-1.106-.893-2-2-2s-2 .894-2 2v4c0 1.107.893 2 2 2m-.8-6.066c0-.44.36-.8.8-.8s.8.36.8.8L8.793 7.4a.797.797 0 1 1-1.593 0zm4.333 4.066c0 2-1.693 3.4-3.533 3.4s-3.533-1.4-3.533-3.4H3.333c0 2.274 1.814 4.154 4 4.48V14h1.334v-2.187c2.186-.32 4-2.2 4-4.48z"
      />
    </g>
  </svg>
)
export default SvgMnone
